<template>
  <svg
    component-name="svg-icon"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    class="[&>*]:fill-current [&>*>*]:fill-current [&>*>*>*]:fill-current"
    :class="{
      'w-2.5 h-2.5 min-w-[10px] min-h-[10px] max-w-[10px] max-h-[10px]':
        size === 'tiny',
      'w-3 h-3 min-w-[12px] min-h-[12px] max-w-[12px] max-h-[12px]':
        size === 'small',
      'w-4 h-4 min-w-[16px] min-h-[16px] max-w-[16px] max-h-[16px]':
        size === 'regular',
      'w-[21px] h-[21px] min-w-[21px] min-h-[21px] max-w-[21px] max-h-[21px]':
        size === 'big',
      'w-[27px] h-[27px] min-w-[27px] min-h-[27px] max-w-[27px] max-h-[27px]':
        size === 'huge',
      'w-[35px] h-[35px] min-w-[35px] min-h-[35px] max-w-[35px] max-h-[35px]':
        size === 'giant',
      'w-[46px] h-[46px] min-w-[46px] min-h-[46px] max-w-[46px] max-h-[46px]':
        size === 'titan',
    }"
    :role="role"
  >
    <circle v-if="icon === 'bullet'" cx="8" cy="8" r="3" />

    <path
      v-else-if="icon === 'close'"
      d="M13.854 2.854a.5.5 0 0 0-.708-.708L8 7.293 2.854 2.146a.5.5 0 1 0-.708.708L7.293 8l-5.147 5.146a.5.5 0 0 0 .708.708L8 8.707l5.146 5.147a.5.5 0 0 0 .708-.708L8.707 8l5.147-5.146z"
    />

    <path
      v-else-if="icon === 'hamburger'"
      d="M1 2.5a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 0 1h-13a.5.5 0 0 1-.5-.5zM1 8a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 0 1h-13A.5.5 0 0 1 1 8zM1.5 13a.5.5 0 0 0 0 1h13a.5.5 0 0 0 0-1h-13z"
    />

    <path
      v-else-if="icon === 'kebab'"
      d="M9.5 2.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zM9.5 13.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zM8 9.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z"
    />

    <path
      v-else-if="icon === 'filters'"
      d="M2.5 1a.5.5 0 0 1 .5.5v1.585a1.5 1.5 0 0 1 0 2.83V14.5a.5.5 0 0 1-1 0V5.915a1.5 1.5 0 0 1 0-2.83V1.5a.5.5 0 0 1 .5-.5zM8.5 1.5a.5.5 0 0 0-1 0v8.585a1.5 1.5 0 0 0 0 2.83V14.5a.5.5 0 0 0 1 0v-1.585a1.5 1.5 0 0 0 0-2.83V1.5zM14 1.5a.5.5 0 0 0-1 0v4.585a1.5 1.5 0 0 0 0 2.83V14.5a.5.5 0 0 0 1 0V8.915a1.5 1.5 0 0 0 0-2.83V1.5z"
    />

    <path
      v-else-if="icon === 'angle-up'"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.854 9.654a.5.5 0 0 1-.708 0L8 6.507 4.854 9.654a.5.5 0 0 1-.708-.707l3.5-3.5a.5.5 0 0 1 .708 0l3.5 3.5a.5.5 0 0 1 0 .707z"
    />

    <path
      v-else-if="icon === 'angle-down'"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.854 6.346a.5.5 0 0 0-.708 0L8 9.493 4.854 6.346a.5.5 0 1 0-.708.708l3.5 3.5a.5.5 0 0 0 .708 0l3.5-3.5a.5.5 0 0 0 0-.708z"
    />

    <path
      v-else-if="icon === 'angle-left'"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9.654 4.146a.5.5 0 0 1 0 .708L6.508 8l3.146 3.146a.5.5 0 0 1-.707.708l-3.5-3.5a.5.5 0 0 1 0-.708l3.5-3.5a.5.5 0 0 1 .707 0z"
    />

    <path
      v-else-if="icon === 'world'"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8 1a7 7 0 1 0 0 14A7 7 0 0 0 8 1zM6.211 2.271A6.005 6.005 0 0 0 2.021 7.5H4.8c.052-1.602.352-3.062.826-4.169a5.59 5.59 0 0 1 .584-1.06zm3.581.001c.22.307.415.666.584 1.06.474 1.106.774 2.566.826 4.168h2.777a6.005 6.005 0 0 0-4.187-5.228zm.409 5.228c-.052-1.491-.332-2.813-.744-3.775-.23-.535-.49-.936-.753-1.196-.261-.258-.498-.353-.703-.353-.204 0-.441.095-.703.353-.263.26-.523.66-.752 1.196-.412.962-.693 2.284-.744 3.775H10.2zm-4.4 1h4.4c-.052 1.491-.332 2.813-.744 3.775-.23.535-.49.936-.753 1.196-.261.258-.498.353-.703.353-.204 0-.441-.095-.703-.353-.263-.26-.523-.661-.752-1.196-.412-.962-.693-2.284-.744-3.775zm-1 0h-2.78a6.005 6.005 0 0 0 4.19 5.229 5.592 5.592 0 0 1-.584-1.06c-.474-1.107-.774-2.567-.826-4.169zm4.991 5.228c.22-.307.415-.666.584-1.06.474-1.106.774-2.566.826-4.168h2.777a6.005 6.005 0 0 1-4.187 5.228z"
    />

    <path
      v-else-if="
        icon === 'user-pro' ||
        (icon === 'user-logged' && userStore.user?.type === 'professional')
      "
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.122 2.094a4.99 4.99 0 1 0-5.47 8.3 7.708 7.708 0 0 0-1.666.757 8.275 8.275 0 0 0-2.926 3.111.5.5 0 0 0 .88.476A7.27 7.27 0 0 1 4.51 12 6.653 6.653 0 0 1 8 11c.55 0 1.097.07 1.63.206a.5.5 0 0 0 .248-.969A7.567 7.567 0 0 0 8 10a4 4 0 1 1 2.5-7.125.5.5 0 0 0 .625-.781h-.003zm3.846 3.23-1.5-4a.5.5 0 0 0-.936 0l-1.5 4A.501.501 0 0 0 11 5.5v9a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-9c0-.06-.01-.12-.032-.176zM13 2.924 13.78 5H12.22l.78-2.076zM14 14h-2V6h2v8z"
    />

    <path
      v-else-if="icon === 'user' || icon === 'user-logged'"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.396 10.39a5 5 0 1 0-4.792 0 7.774 7.774 0 0 0-1.618.756 8.274 8.274 0 0 0-2.926 3.116.5.5 0 0 0 .88.476 7.274 7.274 0 0 1 2.57-2.74A6.652 6.652 0 0 1 8 11c1.223 0 2.427.343 3.49.998a7.274 7.274 0 0 1 2.57 2.74.5.5 0 1 0 .88-.476 8.273 8.273 0 0 0-2.925-3.116 7.772 7.772 0 0 0-1.619-.756zM4 6a4 4 0 1 1 4 4 4 4 0 0 1-4-4z"
    />

    <path
      v-else-if="icon === 'search'"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.5 1a6.5 6.5 0 1 0 4.23 11.436l2.416 2.418a.5.5 0 0 0 .707-.707l-2.417-2.418A6.5 6.5 0 0 0 7.5 1zM2 7.5a5.5 5.5 0 1 1 11 0 5.5 5.5 0 0 1-11 0z"
    />

    <g v-else-if="icon === 'store-locator' || icon === 'pin'">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8 4.5C6.61929 4.5 5.5 5.61929 5.5 7C5.5 8.38071 6.61929 9.5 8 9.5C9.38071 9.5 10.5 8.38071 10.5 7C10.5 5.61929 9.38071 4.5 8 4.5ZM6.5 7C6.5 6.17157 7.17157 5.5 8 5.5C8.82843 5.5 9.5 6.17157 9.5 7C9.5 7.82843 8.82843 8.5 8 8.5C7.17157 8.5 6.5 7.82843 6.5 7Z"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7.72791 14.9195C7.72805 14.9196 7.72818 14.9197 8 14.5L7.72791 14.9195C7.89329 15.0266 8.10644 15.0268 8.27182 14.9197L8 14.5C8.27182 14.9197 8.27168 14.9197 8.27182 14.9197L8.27366 14.9185L8.27748 14.916L8.29099 14.9071L8.34054 14.8741C8.38324 14.8454 8.44488 14.8035 8.52276 14.7491C8.67845 14.6402 8.89933 14.4813 9.1637 14.2785C9.69162 13.8735 10.3972 13.2904 11.1046 12.5788C12.4932 11.182 14 9.18067 14 6.9975C14 3.65988 11.3147 1 8 1C4.68534 1 2 3.65988 2 6.9975C2 9.18067 3.5068 11.182 4.89541 12.5788C5.60284 13.2904 6.30838 13.8735 6.8363 14.2785C7.10067 14.4813 7.32155 14.6402 7.47724 14.7491C7.55512 14.8035 7.61676 14.8454 7.65947 14.8741L7.70901 14.9071L7.72252 14.916L7.72634 14.9185L7.72791 14.9195ZM3 6.9975C3 4.21512 5.23466 2 8 2C10.7653 2 13 4.21512 13 6.9975C13 8.75433 11.7568 10.5043 10.3954 11.8737C9.72784 12.5452 9.05838 13.099 8.55505 13.4851C8.3314 13.6566 8.14138 13.7945 8 13.8942C7.85862 13.7945 7.6686 13.6566 7.44495 13.4851C6.94162 13.099 6.27216 12.5452 5.60459 11.8737C4.2432 10.5043 3 8.75433 3 6.9975Z"
      />
    </g>

    <path
      v-else-if="icon === 'arrow-long-left'"
      d="M4.682 11.89a.5.5 0 0 0 .707-.708L2.707 8.5H14.5a.5.5 0 0 0 0-1H2.707l2.682-2.682a.5.5 0 0 0-.707-.707L1.146 7.646a.5.5 0 0 0 0 .708l3.536 3.535z"
    />

    <path
      v-else-if="icon === 'arrow-long-right'"
      d="M11.318 4.11a.5.5 0 1 0-.707.708L13.292 7.5H1.5a.5.5 0 1 0 0 1h11.793l-2.682 2.682a.5.5 0 0 0 .707.707l3.536-3.535a.5.5 0 0 0 0-.708l-3.536-3.535z"
    />

    <path
      v-else-if="icon === 'arrow-long-down'"
      d="M11.889 11.318a.5.5 0 1 0-.707-.707L8.5 13.292V1.5a.5.5 0 0 0-1 0v11.793l-2.682-2.682a.5.5 0 0 0-.707.707l3.535 3.536a.5.5 0 0 0 .707 0l3.536-3.536z"
    />

    <path
      v-else-if="icon === 'download'"
      d="M8 1a.5.5 0 0 1 .5.5v8.875l3.668-3.25a.5.5 0 1 1 .664.75L8.4 11.798A.5.5 0 0 1 8 12h-.008a.499.499 0 0 1-.34-.127l-4.485-4a.5.5 0 0 1 .666-.746L7.5 10.398V1.5A.5.5 0 0 1 8 1zM2.5 14.5A.5.5 0 0 1 3 14h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z"
    />

    <path
      v-else-if="icon === 'gallery'"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M4.5 2a.5.5 0 0 0-.5.5V6H1.5a.5.5 0 0 0-.5.5v7a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V10h2.5a.5.5 0 0 0 .5-.5v-7a.5.5 0 0 0-.5-.5h-10zm6.5 8H4.5a.5.5 0 0 1-.5-.5V7H2v6h9v-3zm3-1H5V3h9v6z"
    />

    <path
      v-else-if="icon === 'moodboard'"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M1 2.5a.5.5 0 0 1 .5-.5H5a.5.5 0 0 1 .347.14l1.855 1.792H14.5a.5.5 0 0 1 .5.5V13.5a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5v-11zM2 3v10h12V4.932H7a.5.5 0 0 1-.347-.14L4.798 3H2z"
    />

    <g v-else-if="icon === 'add-to-moodboard'">
      <path
        d="M8 6.75a.5.5 0 0 1 .5.5V8.5h1.25a.5.5 0 0 1 0 1H8.5v1.25a.5.5 0 0 1-1 0V9.5H6.25a.5.5 0 0 1 0-1H7.5V7.25a.5.5 0 0 1 .5-.5z"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M1.5 2a.5.5 0 0 0-.5.5v11a.5.5 0 0 0 .5.5h13a.5.5 0 0 0 .5-.5V4.432a.5.5 0 0 0-.5-.5H7.202L5.347 2.14A.5.5 0 0 0 5 2H1.5zM2 13V3h2.798l1.855 1.792a.5.5 0 0 0 .347.14h7V13H2z"
      />
    </g>

    <path
      v-else-if="icon === 'add-to-favorites'"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M6.225 3.353a2.742 2.742 0 0 0-1.905-.295 2.856 2.856 0 0 0-1.66 1.048A3.154 3.154 0 0 0 2 6.046c0 2.097 1.486 4.084 3.093 5.602A20.18 20.18 0 0 0 8 13.912l.01-.007a20.188 20.188 0 0 0 2.897-2.258C12.514 10.13 14 8.144 14 6.046c0-.71-.235-1.395-.66-1.94a2.856 2.856 0 0 0-1.66-1.047 2.742 2.742 0 0 0-1.905.295 2.99 2.99 0 0 0-1.31 1.513.5.5 0 0 1-.93 0 2.99 2.99 0 0 0-1.31-1.513zM8 14.5l.253.431a.5.5 0 0 1-.506 0L8 14.5zM4.114 2.08a3.742 3.742 0 0 1 2.598.4c.512.285.95.683 1.288 1.16a3.93 3.93 0 0 1 1.288-1.16 3.742 3.742 0 0 1 2.598-.4 3.856 3.856 0 0 1 2.242 1.41c.565.723.872 1.627.872 2.555 0 2.539-1.764 4.78-3.407 6.33a21.158 21.158 0 0 1-3.26 2.508l-.057.035-.016.01-.005.002-.002.001L8 14.5l-.253.431-.002-.001-.005-.003-.016-.01-.058-.034c-.05-.031-.123-.076-.214-.135a21.166 21.166 0 0 1-3.045-2.373C2.764 10.825 1 8.584 1 6.045c0-.928.307-1.832.872-2.555a3.856 3.856 0 0 1 2.242-1.41z"
    />

    <path
      v-else-if="icon === 'favourite'"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M6.225 3.353a2.742 2.742 0 0 0-1.905-.295 2.856 2.856 0 0 0-1.66 1.048A3.154 3.154 0 0 0 2 6.046c0 2.097 1.486 4.084 3.093 5.602A20.18 20.18 0 0 0 8 13.912l.01-.007a20.188 20.188 0 0 0 2.897-2.258C12.514 10.13 14 8.144 14 6.046c0-.71-.235-1.395-.66-1.94a2.856 2.856 0 0 0-1.66-1.047 2.742 2.742 0 0 0-1.905.295 2.99 2.99 0 0 0-1.31 1.513.5.5 0 0 1-.93 0 2.99 2.99 0 0 0-1.31-1.513zM8 14.5l.253.431a.5.5 0 0 1-.506 0L8 14.5zM4.114 2.08a3.742 3.742 0 0 1 2.598.4c.512.285.95.683 1.288 1.16a3.93 3.93 0 0 1 1.288-1.16 3.742 3.742 0 0 1 2.598-.4 3.856 3.856 0 0 1 2.242 1.41c.565.723.872 1.627.872 2.555 0 2.539-1.764 4.78-3.407 6.33a21.158 21.158 0 0 1-3.26 2.508l-.057.035-.016.01-.005.002-.002.001L8 14.5l-.253.431-.002-.001-.005-.003-.016-.01-.058-.034c-.05-.031-.123-.076-.214-.135a21.166 21.166 0 0 1-3.045-2.373C2.764 10.825 1 8.584 1 6.045c0-.928.307-1.832.872-2.555a3.856 3.856 0 0 1 2.242-1.41z"
    />

    <path
      v-else-if="icon === 'favourite-added'"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8.262 14.926a7.026 7.026 0 0 0 .286-.178 21.158 21.158 0 0 0 3.045-2.373C13.236 10.825 15 8.584 15 6.045c0-.928-.307-1.832-.872-2.555a3.856 3.856 0 0 0-2.242-1.41 3.742 3.742 0 0 0-2.598.4A3.93 3.93 0 0 0 8 3.64a3.93 3.93 0 0 0-1.288-1.16 3.742 3.742 0 0 0-2.598-.4 3.856 3.856 0 0 0-2.242 1.41A4.154 4.154 0 0 0 1 6.045c0 2.539 1.764 4.78 3.407 6.33a21.166 21.166 0 0 0 3.331 2.551.522.522 0 0 0 .524 0z"
    />

    <path
      v-else-if="icon === 'book-consultancy'"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5 1.5a.5.5 0 0 0-1 0V2H2.09C1.528 2 1 2.431 1 3.045v10.91C1 14.569 1.527 15 2.09 15h11.82c.563 0 1.09-.431 1.09-1.046V3.045C15 2.431 14.473 2 13.91 2H12v-.5a.5.5 0 0 0-1 0V2H5v-.5zM14 5V3.045l-.001-.004a.047.047 0 0 0-.011-.014.116.116 0 0 0-.079-.027H12v.5a.5.5 0 0 1-1 0V3H5v.5a.5.5 0 0 1-1 0V3H2.09a.116.116 0 0 0-.078.027.048.048 0 0 0-.011.014L2 3.045V5h12zM2 6h12V13.956l-.001.003a.046.046 0 0 1-.011.014.115.115 0 0 1-.079.027H2.091a.115.115 0 0 1-.079-.027.047.047 0 0 1-.011-.014L2 13.954V6z"
    />

    <path
      v-else-if="icon === 'plus'"
      d="M8.5 1.5a.5.5 0 0 0-1 0v6h-6a.5.5 0 0 0 0 1h6v6a.5.5 0 0 0 1 0v-6h6a.5.5 0 0 0 0-1h-6v-6z"
    />

    <path
      v-else-if="icon === 'minus'"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M1 8a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 0 1h-13A.5.5 0 0 1 1 8z"
    />

    <path
      v-else-if="icon === 'email'"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M1.5 3a.5.5 0 0 0-.5.5v9a.5.5 0 0 0 .5.5h13a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5h-13zM2 4.583V12h12V4.573L8.256 8.96a.5.5 0 0 1-.61-.002L2 4.583zM13.103 4H2.88l5.074 3.932L13.103 4z"
    />

    <g v-else-if="icon === 'info'">
      <path
        d="M6.5 7a.5.5 0 0 1 .5-.5h1.5a.5.5 0 0 1 .485.621L8.14 10.5H9a.5.5 0 0 1 0 1H6a.5.5 0 0 1 0-1h1.11l.75-3H7a.5.5 0 0 1-.5-.5zM8.625 5.5a.875.875 0 1 0 0-1.75.875.875 0 0 0 0 1.75z"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M1 8a7 7 0 1 1 14 0A7 7 0 0 1 1 8zm7-6a6 6 0 1 0 0 12A6 6 0 0 0 8 2z"
      />
    </g>

    <path
      v-else-if="icon === 'success'"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M14.833 3.127a.5.5 0 0 1 .04.706l-8.667 9.709a.5.5 0 0 1-.726.02L1.146 9.23a.5.5 0 1 1 .708-.708l3.959 3.96 8.314-9.315a.5.5 0 0 1 .706-.04z"
    />

    <g v-else-if="icon === 'warning'">
      <path
        d="M8 4.94c.269 0 .487.225.487.503V9.97a.495.495 0 0 1-.488.503.495.495 0 0 1-.487-.503V5.443c0-.278.218-.503.487-.503zM8 12.988a.743.743 0 0 0 .73-.755.743.743 0 0 0-.73-.754.743.743 0 0 0-.732.755c0 .416.327.754.731.754z"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M1.167 12.795 6.702 1.813a1.442 1.442 0 0 1 2.596 0l5.535 10.982c.506 1.004-.2 2.205-1.298 2.205H2.465c-1.098 0-1.804-1.2-1.298-2.205zm6.4-10.518L2.032 13.259c-.169.335.067.735.433.735h11.07c.366 0 .602-.4.433-.735L8.433 2.277a.48.48 0 0 0-.866 0z"
      />
    </g>

    <path
      v-else-if="icon === 'error'"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="m2.948 12.845-.302.301a.5.5 0 0 0 .708.708l.337-.337a7 7 0 0 0 9.826-9.826l.337-.337a.5.5 0 0 0-.708-.708l-.3.302a7 7 0 0 0-9.897 9.897zM2 8a6 6 0 0 1 10.138-4.345l-8.483 8.483A5.98 5.98 0 0 1 2 8zm10.803-3.596a6 6 0 0 1-8.4 8.4l8.4-8.4z"
    />

    <g v-else-if="icon === 'lock'">
      <path d="M8.5 8.5a.5.5 0 0 0-1 0v3a.5.5 0 0 0 1 0v-3z" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M5 3.5V5H2.5a.5.5 0 0 0-.5.5v9a.5.5 0 0 0 .5.5h11a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5H11V3.5A2.5 2.5 0 0 0 8.5 1h-1A2.5 2.5 0 0 0 5 3.5zM7.5 2A1.5 1.5 0 0 0 6 3.5V5h4V3.5A1.5 1.5 0 0 0 8.5 2h-1zM13 6v8H3V6h10z"
      />
    </g>

    <g v-else-if="icon === 'remove'">
      <path
        d="M6.5 6a.5.5 0 0 1 .5.5v5a.5.5 0 0 1-1 0v-5a.5.5 0 0 1 .5-.5zM10 11.5v-5a.5.5 0 0 0-1 0v5a.5.5 0 0 0 1 0z"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M6.5 1A1.5 1.5 0 0 0 5 2.5V3H2.5a.5.5 0 0 0 0 1H3v9.95c0 .264.095.526.276.725A.978.978 0 0 0 4 15h8c.281 0 .54-.123.723-.325.182-.2.277-.461.277-.725V4h.5a.5.5 0 0 0 0-1H11v-.5A1.5 1.5 0 0 0 9.5 1h-3zM10 3v-.5a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5V3h4zM4 4v9.95c0 .025.008.042.014.05h7.972a.085.085 0 0 0 .014-.05V4H4z"
      />
    </g>

    <g v-else-if="icon === 'share'">
      <path
        d="M2 2.5a.5.5 0 0 0-1 0v11a.5.5 0 0 0 .5.5h13a.5.5 0 0 0 0-1H2V2.5z"
      />
      <path
        d="M11.146 2.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L13.293 6H10.31a5.5 5.5 0 0 0-3.37 1.151c-.977.757-1.654 1.793-1.851 2.711-.08.381-.09.61-.09.64l-.001.003a.5.5 0 0 1-1-.008v-.004c.004-.281.055-.564.112-.838v-.002c.257-1.191 1.092-2.42 2.218-3.293A6.5 6.5 0 0 1 10.31 5h2.983l-2.147-2.146a.5.5 0 0 1 0-.708z"
      />
    </g>

    <g v-else-if="icon === 'url'">
      <path
        d="m9.306 2.791-2.04 2.037a.5.5 0 0 1-.707-.708l2.044-2.04a3.76 3.76 0 0 1 5.317 5.317l-.003.003-2.041 2.038a.5.5 0 1 1-.707-.707l2.04-2.037a2.76 2.76 0 0 0-3.903-3.903z"
      />
      <path
        d="M10.527 5.471a.5.5 0 0 1 0 .707L6.18 10.525a.5.5 0 0 1-.707-.707L9.819 5.47a.5.5 0 0 1 .707 0z"
      />
      <path
        d="M4.828 7.264a.5.5 0 1 0-.708-.706L2.082 8.6l-.002.002a3.76 3.76 0 0 0 5.317 5.318l2.041-2.045a.5.5 0 1 0-.707-.707l-2.037 2.04a2.76 2.76 0 0 1-3.903-3.903l2.037-2.04z"
      />
    </g>

    <path
      v-else-if="icon === 'work-with-us'"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10 1c-1.419 0-2.646.818-3.238 2.007a4.308 4.308 0 0 0-1.973 7.998 6.668 6.668 0 0 0-1.226.591 7.078 7.078 0 0 0-2.503 2.666.5.5 0 1 0 .88.476 6.078 6.078 0 0 1 2.147-2.29A5.551 5.551 0 0 1 7 11.616c1.02 0 2.025.286 2.913.832a6.077 6.077 0 0 1 2.147 2.29.5.5 0 0 0 .88-.476 7.077 7.077 0 0 0-2.503-2.665c-.39-.24-.8-.438-1.224-.592a4.316 4.316 0 0 0 1.959-2.615c.405.113.796.283 1.163.509a4.882 4.882 0 0 1 1.725 1.84.5.5 0 0 0 .88-.477 5.882 5.882 0 0 0-2.08-2.215 5.56 5.56 0 0 0-.848-.427A3.615 3.615 0 0 0 10 1zm0 1c-.874 0-1.648.43-2.124 1.09a4.31 4.31 0 0 1 3.413 3.802A2.615 2.615 0 0 0 10.001 2zM3.694 7.308a3.308 3.308 0 1 1 6.616 0 3.308 3.308 0 0 1-6.616 0z"
    />

    <g v-else-if="icon === 'faq'">
      <path
        d="M5.608 4.626C6.25 4.214 7.1 4 8 4c.9 0 1.75.214 2.392.626.648.417 1.108 1.06 1.108 1.874 0 .815-.46 1.457-1.108 1.874-.521.334-1.18.539-1.892.604V9.5a.5.5 0 0 1-1 0v-1A.5.5 0 0 1 8 8c.756 0 1.406-.182 1.85-.468.439-.281.65-.639.65-1.032s-.211-.75-.65-1.032C9.407 5.182 8.757 5 8 5s-1.406.182-1.85.468c-.439.281-.65.639-.65 1.032V7a.5.5 0 0 1-1 0v-.5c0-.815.46-1.457 1.108-1.874zM8 12.5A.75.75 0 1 0 8 11a.75.75 0 0 0 0 1.5z"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M1 8a7 7 0 1 1 14 0A7 7 0 0 1 1 8zm7-6a6 6 0 1 0 0 12A6 6 0 0 0 8 2z"
      />
    </g>

    <g v-else-if="icon === 'duplicate'">
      <path
        d="M4.25 6.5a.5.5 0 0 1 .5-.5H6V4.75a.5.5 0 0 1 1 0V6h1.25a.5.5 0 0 1 0 1H7v1.25a.5.5 0 0 1-1 0V7H4.75a.5.5 0 0 1-.5-.5z"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M1.5 1a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5v-10a.5.5 0 0 0-.5-.5h-10zM2 11V2h9v9H2z"
      />
      <path
        d="M5 14.5a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0 0 1h.5v8H6v-.5a.5.5 0 0 0-1 0v1z"
      />
    </g>

    <path
      v-else-if="icon === 'configurator'"
      d="M8.224 1.053a.5.5 0 0 0-.448 0l-1.95.975a.5.5 0 1 0 .448.894L8 2.06l1.726.863a.5.5 0 1 0 .448-.894l-1.95-.975zM3.674 4.222a.5.5 0 1 0-.448-.894l-1.95.975A.5.5 0 0 0 1 4.75V6.7a.5.5 0 0 0 1 0V5.559l5.5 2.75v5.383l-1.226-.614a.5.5 0 1 0-.448.894l1.95.975a.5.5 0 0 0 .448 0l1.95-.975a.5.5 0 1 0-.448-.894l-1.225.613V8.309L14 5.559V6.7a.5.5 0 0 0 1 0V4.75a.5.5 0 0 0-.276-.447l-1.95-.975a.5.5 0 1 0-.448.894l1.056.528-5.381 2.691L2.619 4.75l1.055-.528zM15 9.3a.5.5 0 0 0-1 0v1.641l-1.674.837a.5.5 0 1 0 .448.894l1.95-.975A.5.5 0 0 0 15 11.25V9.3zM2 9.3a.5.5 0 0 0-1 0v1.95a.5.5 0 0 0 .276.447l1.95.975a.5.5 0 1 0 .448-.894L2 10.94V9.3z"
    />

    <g v-else-if="icon === 'edit'">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="m6.663 14 5.9-5.902a.525.525 0 0 0 .057-.057l2.068-2.068a1.065 1.065 0 0 0 0-1.506l-3.157-3.155a1.065 1.065 0 0 0-1.506 0l-8.713 8.713c-.2.2-.312.47-.312.752v3.158A1.065 1.065 0 0 0 2.065 15h3.391m5.276-12.981L8.99 3.761l3.248 3.248 1.743-1.743-3.25-3.247zm-8.713 8.713 6.264-6.264 3.248 3.248L5.25 14H2.065A.065.065 0 0 1 2 13.935v-3.158c0-.017.007-.033.02-.045z"
      />
      <path d="M6.663 14h6.833a.5.5 0 0 1 0 1h-8.04" />
    </g>

    <path
      v-else-if="icon === 'mail'"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M1.5 3a.5.5 0 0 0-.5.5v9a.5.5 0 0 0 .5.5h13a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5h-13zM2 4.583V12h12V4.573L8.256 8.96a.5.5 0 0 1-.61-.002L2 4.583zM13.103 4H2.88l5.074 3.932L13.103 4z"
    />

    <path
      v-else-if="icon === 'thumbs-list'"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M13 3H3v10h10V3zM3 2a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1H3z"
    />

    <path
      v-else-if="icon === 'thumbs-grid'"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M2 3a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3zm1 0h3v3H3V3zM9 3a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-3a1 1 0 0 1-1-1V3zm1 0h3v3h-3V3zM10 9a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1h-3zm3 1h-3v3h3v-3zM2 10a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-3zm1 0h3v3H3v-3z"
    />

    <path
      v-else-if="icon === 'play'"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M4.272 1.055a.5.5 0 0 1 .52.04l9 6.5a.5.5 0 0 1 0 .81l-9 6.5A.5.5 0 0 1 4 14.5v-13a.5.5 0 0 1 .272-.445zM5 2.478v11.044L12.646 8 5 2.478z"
    />

    <path
      v-else-if="icon === 'pause'"
      d="M5 1.5a.5.5 0 0 0-1 0v13a.5.5 0 0 0 1 0v-13zM12 1.5a.5.5 0 0 0-1 0v13a.5.5 0 0 0 1 0v-13z"
    />

    <g v-else-if="icon === 'audio-on'">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8.712 1.047A.5.5 0 0 1 9 1.5v13a.5.5 0 0 1-.82.385l-4.86-4.04H1.5a.5.5 0 0 1-.5-.5v-4.69a.5.5 0 0 1 .5-.5h1.82l4.86-4.04a.5.5 0 0 1 .532-.068zM8 2.566 3.82 6.039a.5.5 0 0 1-.32.116H2v3.69h1.5a.5.5 0 0 1 .32.116L8 13.434V2.566z"
      />
      <path
        d="M12.754 3.62a.5.5 0 0 1 .706.054 6.29 6.29 0 0 1 1.143 1.993c.263.742.398 1.534.398 2.333 0 .799-.135 1.591-.398 2.333a6.291 6.291 0 0 1-1.143 1.993.5.5 0 0 1-.76-.652 5.289 5.289 0 0 0 .96-1.676c.225-.632.341-1.31.341-1.998 0-.687-.116-1.366-.34-1.998a5.29 5.29 0 0 0-.96-1.676.5.5 0 0 1 .053-.705zM11.767 5.697a.5.5 0 0 0-.795.606c.162.213.295.472.388.765.092.293.14.61.14.932 0 .322-.048.64-.14.932a2.502 2.502 0 0 1-.388.765.5.5 0 0 0 .795.606 3.5 3.5 0 0 0 .546-1.07c.125-.393.188-.812.188-1.233 0-.421-.063-.84-.188-1.233a3.5 3.5 0 0 0-.546-1.07z"
      />
    </g>

    <g v-else-if="icon === 'audio-off'">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M9 1.5a.5.5 0 0 0-.82-.385l-4.86 4.04H1.5a.5.5 0 0 0-.5.5v4.69a.5.5 0 0 0 .5.5h1.82l4.86 4.04A.5.5 0 0 0 9 14.5v-13zM3.82 6.04 8 2.565v10.869L3.82 9.96a.5.5 0 0 0-.32-.116H2v-3.69h1.5a.5.5 0 0 0 .32-.116z"
      />
      <path
        d="M10.646 5.896a.5.5 0 0 1 .708 0l1.396 1.397 1.396-1.397a.5.5 0 0 1 .708.708L13.457 8l1.397 1.396a.5.5 0 0 1-.708.708L12.75 8.707l-1.396 1.397a.5.5 0 0 1-.708-.708L12.043 8l-1.397-1.396a.5.5 0 0 1 0-.708z"
      />
    </g>

    <path
      v-else-if="icon === 'fullscreen-on'"
      d="M1 5.5a.5.5 0 0 0 1 0V2h3.5a.5.5 0 0 0 0-1h-4a.5.5 0 0 0-.5.5v4zM1 10.5a.5.5 0 0 1 1 0V14h3.5a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5v-4zM14.5 6a.5.5 0 0 0 .5-.5v-4a.5.5 0 0 0-.5-.5h-4a.5.5 0 0 0 0 1H14v3.5a.5.5 0 0 0 .5.5zM15 10.5a.5.5 0 0 0-1 0V14h-3.5a.5.5 0 0 0 0 1h4a.5.5 0 0 0 .5-.5v-4z"
    />

    <path
      v-else-if="icon === 'fullscreen-off'"
      d="M6 1.5a.5.5 0 0 0-1 0V5H1.5a.5.5 0 0 0 0 1h4a.5.5 0 0 0 .5-.5v-4zM6 14.5a.5.5 0 0 1-1 0V11H1.5a.5.5 0 0 1 0-1h4a.5.5 0 0 1 .5.5v4zM10.5 1a.5.5 0 0 0-.5.5v4a.5.5 0 0 0 .5.5h4a.5.5 0 0 0 0-1H11V1.5a.5.5 0 0 0-.5-.5zM10 14.5a.5.5 0 0 0 1 0V11h3.5a.5.5 0 0 0 0-1h-4a.5.5 0 0 0-.5.5v4z"
    />

    <g v-else-if="icon === 'certification'">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M2.293 1.293A1 1 0 0 1 3 1h7a.5.5 0 0 1 .354.146l3.466 3.466A.5.5 0 0 1 14 5v9a1 1 0 0 1-1 1h-2.5a.5.5 0 0 1 0-1H13V5.5h-3a.5.5 0 0 1-.5-.5V2H3v5.5a.5.5 0 0 1-1 0V2a1 1 0 0 1 .293-.707zM10.5 2.707 12.293 4.5H10.5V2.707z"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M3.5 9a3 3 0 1 1 4.55 2.57l.924 2.772a.5.5 0 0 1-.65.626L6.5 14.284l-1.824.684a.5.5 0 0 1-.65-.626l.924-2.773A2.999 2.999 0 0 1 3.5 9zm3-2a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm0 5c.212 0 .419-.022.618-.064l.576 1.728-1.018-.382a.5.5 0 0 0-.351 0l-1.02.382.577-1.728c.2.042.406.064.618.064z"
      />
    </g>

    <g v-else-if="icon === 'handbook-maintenance'">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M2.293 1.293A1 1 0 0 1 3 1h7a.5.5 0 0 1 .354.146l3.466 3.466A.5.5 0 0 1 14 5v9a1 1 0 0 1-1 1h-2.5a.5.5 0 0 1 0-1H13V5.5h-3a.5.5 0 0 1-.5-.5V2H3v5.5a.5.5 0 0 1-1 0V2a1 1 0 0 1 .293-.707zM10.5 2.707 12.293 4.5H10.5V2.707z"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8.396 6.855a3.167 3.167 0 0 0-4.247 3.749l-1.716 1.839a1.502 1.502 0 0 0 2.126 2.121l1.8-1.723a3.166 3.166 0 0 0 3.786-4.237.5.5 0 0 0-.78-.2L7.807 9.683l-.489-.49 1.277-1.557a.5.5 0 0 0-.199-.78zm-1.682.826c.196-.046.397-.064.596-.055L6.258 8.91a.5.5 0 0 0 .033.67l1.13 1.13a.5.5 0 0 0 .67.034L9.374 9.69a2.166 2.166 0 0 1-2.959 2.115.5.5 0 0 0-.53.104l-2.02 1.935-.009.008a.502.502 0 1 1-.697-.722l1.92-2.06a.5.5 0 0 0 .103-.516A2.167 2.167 0 0 1 6.714 7.68z"
      />
    </g>

    <g v-else-if="icon === 'handbook-laying'">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M2.293 1.293A1 1 0 0 1 3 1h7a.5.5 0 0 1 .354.146l3.466 3.466A.5.5 0 0 1 14 5v9a1 1 0 0 1-1 1h-2.5a.5.5 0 0 1 0-1H13V5.5h-3a.5.5 0 0 1-.5-.5V2H3v5.5a.5.5 0 0 1-1 0V2a1 1 0 0 1 .293-.707zM10.5 2.707 12.293 4.5H10.5V2.707z"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M1.317 11.034a.5.5 0 0 0 0 .93l4.95 1.95a.5.5 0 0 0 .366 0l4.95-1.95a.5.5 0 0 0 0-.93l-4.95-1.95a.5.5 0 0 0-.367 0l-4.95 1.95zm5.133 1.878L2.864 11.5l3.586-1.413 3.585 1.413-3.585 1.412z"
      />
    </g>

    <g v-else-if="icon === 'handbook-cleaning'">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M2.293 1.293A1 1 0 0 1 3 1h7a.5.5 0 0 1 .354.146l3.466 3.466A.5.5 0 0 1 14 5v9a1 1 0 0 1-1 1h-2.5a.5.5 0 0 1 0-1H13V5.5h-3a.5.5 0 0 1-.5-.5V2H3v5.5a.5.5 0 0 1-1 0V2a1 1 0 0 1 .293-.707zM10.5 2.707 12.293 4.5H10.5V2.707z"
      />
      <path
        d="M5.338 11.195a.5.5 0 0 0-.41.576c.121.71.7 1.29 1.41 1.41a.5.5 0 1 0 .167-.986.745.745 0 0 1-.59-.591.5.5 0 0 0-.577-.41z"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="m6.207 6.095.001-.001a.5.5 0 0 1 .584 0l.041.03.104.08A10.38 10.38 0 0 1 8.381 7.6C9.161 8.52 10 9.864 10 11.424c0 .945-.366 1.853-1.02 2.525A3.462 3.462 0 0 1 6.5 15c-.932 0-1.824-.38-2.48-1.052A3.617 3.617 0 0 1 3 11.423c0-1.56.84-2.905 1.619-3.823a10.38 10.38 0 0 1 1.548-1.475l.04-.03zM6.5 7.137l-.14.12a9.38 9.38 0 0 0-.979.99C4.661 9.096 4 10.213 4 11.422c0 .688.266 1.344.737 1.827.47.482 1.104.75 1.763.75.659 0 1.293-.268 1.763-.75.47-.483.737-1.14.737-1.827 0-1.209-.66-2.326-1.381-3.177A9.38 9.38 0 0 0 6.5 7.137z"
      />
    </g>

    <g v-else-if="icon === 'handbook-informative'">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M2.293 1.293A1 1 0 0 1 3 1h7a.5.5 0 0 1 .354.146l3.466 3.466A.5.5 0 0 1 14 5v9a1 1 0 0 1-1 1h-2.5a.5.5 0 0 1 0-1H13V5.5h-3a.5.5 0 0 1-.5-.5V2H3v5.5a.5.5 0 0 1-1 0V2a1 1 0 0 1 .293-.707zM10.5 2.707 12.293 4.5H10.5V2.707z"
      />
      <path
        d="M7.5 7.375a.875.875 0 1 1-1.75 0 .875.875 0 0 1 1.75 0zM4.5 9.5A.5.5 0 0 1 5 9h1.5a.5.5 0 0 1 .479.644L5.672 14h.86a.5.5 0 0 1 0 1H3.5a.5.5 0 0 1 0-1h1.128l1.2-4H5a.5.5 0 0 1-.5-.5z"
      />
    </g>

    <g v-else-if="icon === 'monograph-catalog'">
      <path
        fill-rule="evenodd"
        d="M3 1a1 1 0 0 0-1 1v5.016a.5.5 0 1 0 1 0V2h6.5v3a.5.5 0 0 0 .5.5h3V14h-2.5a.5.5 0 0 0 0 1H13a1 1 0 0 0 1-1V5a.5.5 0 0 0-.18-.387l-3.466-3.466A.5.5 0 0 0 10 1H3Zm9.293 3.5L10.5 2.707V4.5h1.793Z"
        clip-rule="evenodd"
      />
      <path
        fill-rule="evenodd"
        d="M2.183 8.576a.715.715 0 0 1 .55-.263H4.6c.357 0 .683.148.932.39.25-.242.576-.39.933-.39H8.33c.228 0 .423.11.55.263.125.15.184.338.184.518v4.5c0 .18-.059.367-.184.518a.715.715 0 0 1-.55.263H6.464c-.081 0-.183.038-.275.149a.754.754 0 0 0-.158.476.5.5 0 1 1-1 0 .754.754 0 0 0-.158-.476c-.091-.11-.193-.149-.274-.149H2.733a.715.715 0 0 1-.55-.263.813.813 0 0 1-.183-.518v-4.5c0-.18.058-.367.183-.518Zm3.848 4.874V9.938a.76.76 0 0 1 .158-.477c.092-.11.194-.148.275-.148h1.598v4.062H6.465c-.15 0-.296.027-.433.075ZM4.873 9.461a.754.754 0 0 1 .158.477v3.512a1.284 1.284 0 0 0-.432-.075H3V9.313h1.599c.08 0 .183.038.274.148Z"
        clip-rule="evenodd"
      />
    </g>

    <g v-else-if="icon === 'password-visible'">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M11 8a3 3 0 1 1-6 0 3 3 0 0 1 6 0zm-1 0a2 2 0 1 1-4 0 2 2 0 0 1 4 0z"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M14.931 8.252a.502.502 0 0 0 0-.504v-.001l-.002-.004-.008-.013-.027-.045-.104-.167a16.208 16.208 0 0 0-1.83-2.36C11.767 3.888 10.015 2.5 8 2.5S4.233 3.889 3.04 5.157a16.213 16.213 0 0 0-1.934 2.528l-.028.045-.007.013-.002.004a.501.501 0 0 0-.001.505L1.5 8l-.432.252v.001l.003.004.007.013.028.045a15.049 15.049 0 0 0 .496.753c.338.483.829 1.128 1.437 1.775C4.233 12.11 5.985 13.5 8 13.5c2.016 0 3.768-1.389 4.961-2.657a16.215 16.215 0 0 0 1.934-2.528l.027-.045.008-.013.002-.004zM2.42 8.494A14.31 14.31 0 0 1 2.088 8a15.214 15.214 0 0 1 1.68-2.157C4.927 4.61 6.425 3.5 8 3.5c1.575 0 3.073 1.111 4.232 2.343A15.209 15.209 0 0 1 13.912 8a15.204 15.204 0 0 1-1.68 2.157C11.072 11.39 9.575 12.5 8 12.5c-1.575 0-3.073-1.111-4.232-2.343A15.209 15.209 0 0 1 2.42 8.494zM1.5 8l-.432-.252L1.5 8z"
      />
    </g>

    <g v-else-if="icon === 'password-hidden'">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M13.354 2.646a.5.5 0 0 1 0 .708L12.25 4.457c.254.232.492.468.71.7a16.208 16.208 0 0 1 1.934 2.528l.027.045.008.013.002.004v.001L14.5 8l.431.252v.001l-.002.004-.008.013-.027.045-.104.167a16.215 16.215 0 0 1-1.83 2.36C11.767 12.112 10.015 13.5 8 13.5c-1.293 0-2.478-.572-3.476-1.317l-1.17 1.17a.5.5 0 0 1-.708-.707l1.104-1.103a12.81 12.81 0 0 1-.71-.7 16.22 16.22 0 0 1-1.934-2.528l-.028-.045-.007-.013-.002-.004-.001-.001a.501.501 0 0 1 0-.504L1.5 8l-.432-.252v-.001l.003-.004.007-.013.028-.045a15.035 15.035 0 0 1 .496-.753c.338-.483.829-1.128 1.437-1.775C4.233 3.89 5.985 2.5 8 2.5c1.294 0 2.479.572 3.477 1.317l1.17-1.17a.5.5 0 0 1 .708 0zM10.76 4.532C9.91 3.922 8.97 3.5 8 3.5c-1.575 0-3.073 1.111-4.232 2.343A15.214 15.214 0 0 0 2.088 8a15.209 15.209 0 0 0 1.68 2.157c.218.233.45.46.69.678l1.097-1.097a3 3 0 0 1 4.184-4.184l1.021-1.022zm-5.52 6.936c.85.61 1.79 1.032 2.76 1.032 1.575 0 3.073-1.111 4.232-2.343A15.204 15.204 0 0 0 13.912 8a15.209 15.209 0 0 0-1.68-2.157c-.219-.233-.45-.46-.69-.678l-6.303 6.303zm3.776-5.191-2.74 2.739a2 2 0 0 1 2.74-2.74z"
      />
      <path d="M14.931 8.252 14.5 8l.432-.252c.09.156.09.349 0 .504z" />
    </g>

    <g v-else-if="icon === 'external-link'">
      <path
        d="m9.306 2.791-2.04 2.037a.5.5 0 0 1-.707-.708l2.044-2.04a3.76 3.76 0 0 1 5.317 5.317l-.003.003-2.041 2.038a.5.5 0 1 1-.707-.707l2.04-2.037a2.76 2.76 0 0 0-3.903-3.903z"
      />
      <path
        d="M10.527 5.471a.5.5 0 0 1 0 .707L6.18 10.525a.5.5 0 0 1-.707-.707L9.819 5.47a.5.5 0 0 1 .707 0z"
      />
      <path
        d="M4.828 7.264a.5.5 0 1 0-.708-.706L2.082 8.6l-.002.002a3.76 3.76 0 0 0 5.317 5.318l2.041-2.045a.5.5 0 1 0-.707-.707l-2.037 2.04a2.76 2.76 0 0 1-3.903-3.903l2.037-2.04z"
      />
    </g>

    <g v-else-if="icon === 'hires-img'">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M4 6a2 2 0 1 1 4 0 2 2 0 0 1-4 0zm2-1a1 1 0 1 0 0 2 1 1 0 0 0 0-2z"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M15 2.09A1.09 1.09 0 0 0 13.91 1H2.09A1.09 1.09 0 0 0 1 2.09v11.82c0 .602.488 1.09 1.09 1.09h11.82A1.09 1.09 0 0 0 15 13.91V2.09zM2.09 2a.09.09 0 0 0-.09.09v11.82c0 .05.04.09.09.09h.703l6.695-6.695a1.106 1.106 0 0 1 .77-.305 1.132 1.132 0 0 1 .772.305l.01.01L14 10.289V2.09A.09.09 0 0 0 13.91 2H2.09zM14 11.706l-3.662-3.678a.108.108 0 0 0-.031-.02.131.131 0 0 0-.127.02L4.207 14h9.702c.05 0 .091-.04.091-.09v-2.204z"
      />
    </g>

    <g v-else-if="icon === 'resource'">
      <path
        d="M1.656 2.192h.107v.114h-.107v-.114ZM.24 2.457h.206v.217H.24v-.217Zm2.198.457h.206v.218h-.206v-.218Zm2.745.317h.206v.218h-.206v-.218Z"
      />
      <path
        fill-rule="evenodd"
        d="M7.13 8.706c.484-.484.765-1.115.842-1.892a.525.525 0 0 0-.158-.436h.213V6h-.243a.308.308 0 0 0-.225-.521.31.31 0 0 0-.307.343.303.303 0 0 0-.077 0 .184.184 0 0 0-.141-.254V5.29h-.351a.281.281 0 1 0-.55-.03H5.89v.2a.2.2 0 1 0-.007.39.309.309 0 0 0 0 .526.555.555 0 0 0-.155.346h-.005a1.26 1.26 0 0 1-.344.625c-.254.254-.583.382-.986.382H2.26v-.125h-.172a.386.386 0 0 0 .015-.63h.122v-.481h-.058a.153.153 0 1 0-.22-.208V6.17h-.174v.14a.231.231 0 0 0-.372-.1h-.353v.204a.218.218 0 0 0-.115-.072v-.214a.31.31 0 0 0 .216-.576h.16v-.027a.14.14 0 1 0 0-.138v-.18H.98v.316a.31.31 0 0 0-.258.41H.5v.403a.262.262 0 0 0-.106-.117.218.218 0 0 0-.206-.344v-.15H0v.197h.08a.218.218 0 0 0-.002.336.26.26 0 0 0 .02.391H0v.38h.073a.274.274 0 0 0 .005.378.42.42 0 0 0-.071.318H0v5.33h2.16V9.744h2.016l1.8 3.312h2.377L6.264 9.312c.336-.144.624-.345.865-.605Zm.43-2.61a.306.306 0 0 0 .107-.02v.203a.527.527 0 0 0-.164-.046.307.307 0 0 0 .017-.14.304.304 0 0 0 .04.003Zm-.733-.393a.185.185 0 0 0 .147.228.311.311 0 0 0-.035.053h-.237v-.281h.125Zm-6.166.85c0 .036.009.07.024.1a.363.363 0 0 0-.081.084v-.23H.516a.265.265 0 0 0 .002-.118h.218a.217.217 0 0 0-.075.164Zm.564.221a.363.363 0 0 0-.141-.146.208.208 0 0 0 .01-.038h.235a.29.29 0 0 0-.104.184Zm.543-.097a.295.295 0 0 0-.09-.1.23.23 0 0 0 .104-.223h.14v.005l-.002.01c0 .05.025.095.062.123h-.214v.185Zm4.572-.471a.31.31 0 0 0 .005-.166h.164v.21a.552.552 0 0 0-.17-.044Zm-.293-.553a.199.199 0 0 1-.08.16.308.308 0 0 1 .304.087v-.315h.37V5.38a.28.28 0 0 1-.423.043v.18H6.04a.198.198 0 0 1 .006.05Z"
        clip-rule="evenodd"
      />
      <path
        d="M7.84 5.589c0 .059.045.107.1.107.056 0 .1-.048.1-.107 0-.06-.044-.107-.1-.107-.055 0-.1.048-.1.107ZM2.732 3.532h-.248v.262h.248v-.262ZM.705 3.353H.498v.218h.207v-.218ZM6.75 4.901h.297v.314H6.75V4.9ZM.916 4.81H.618v.313h.298v-.314Zm2.914-.114h.298v.313H3.83v-.313Zm-1.833-1.44H1.79v.218h.207v-.218ZM7.21 4.744h.298v.313H7.21v-.313Zm-6.12-.756H.794V4.3h.298v-.313Zm4.537-.537h.248v.262h-.248V3.45Zm-.753-.461h-.206v.218h.206V2.99Zm-1.41-.12h-.207v.218h.207v-.217ZM2.353 3.955h.298v.313h-.245v.347h-.36v-.38h.307v-.28Zm-1.136.444h-.36v.379h.36v-.38Zm4.362-.409h.36v.38h-.36v-.38Zm1.175.037h-.36v.379h.36v-.38ZM4.3 4.63h.36v.38H4.3v-.38Zm-.484-.983h-.248v.262h.248v-.262Zm.3-.475h.207v.218h-.207v-.218Zm.907 1.26h-.298v.313h.298v-.313Zm1.583-.826h.248v.262h-.248v-.262ZM1.5 5.074h-.155v.163H1.5v-.163Zm.283-2.418h.13v.136h-.13v-.136Zm4.392.473h-.107v.113h.107V3.13Zm-.943-.392h.108v.113h-.108v-.113Zm-4.76.418H.364v.114h.108v-.114Zm4.245-.533h.108v.114h-.108v-.114Zm-4.609.363H0V3.1h.108v-.114Zm2.064-.494h.108v.114h-.108V2.49Zm.043.419h-.108v.113h.108v-.114ZM5.47 4.107h-.13v.136h.13v-.136ZM3.514 2.525h.108v.113h-.108v-.113ZM7 4.243h-.156v.164H7v-.164ZM.864 3.027h.108v.114H.864v-.114Zm2.094.953h-.13v.135h.13V3.98Zm1.94-.64h.13v.137h-.13v-.136Zm1.265.472h-.13v.136h.13v-.136Zm-2.203.104h.247v.262H3.96v-.262Zm-.594 0h-.248v.262h.248v-.262Zm2.289.926h.298v.314h-.298v-.314ZM1.65 3.559h-.248v.261h.248v-.26ZM2.94 4.56h-.236v-.313h.298v.274a.256.256 0 0 1 .354.174h.29v.314H3.35v-.174a.255.255 0 1 1-.409-.275ZM.249 3.668H0v.261h.248v-.261Zm2.112 1.02Z"
      />
      <path
        d="M2.064 4.688h.297v.313h-.273a.255.255 0 0 1-.17.207h.016v.123h.287v.345h-.328v-.123h-.287v-.345h.147a.255.255 0 0 1-.157-.331h-.284v-.314h.298v.283a.255.255 0 0 1 .453.005v-.163Zm-.21-.548H1.71v.152h.144v-.151ZM.82 3.398h.143v.152H.819v-.152Zm5.73 1.296h-.143v.151h.144v-.151Zm-5.31-2.32h.144v.151H1.24v-.151Zm3.83 1.725h-.144v.151h.144V4.1Zm.811-.987a.125.125 0 1 1-.25 0 .125.125 0 0 1 .25 0ZM0 3.394a.125.125 0 1 0 .25 0 .125.125 0 0 0-.25 0Zm1.315 1.572a.18.18 0 1 1-.36 0 .18.18 0 0 1 .36 0Zm.875-1.572a.125.125 0 1 0 .25 0 .125.125 0 0 0-.25 0Zm1.786-.404a.125.125 0 1 1-.25 0 .125.125 0 0 1 .25 0Zm.551 1.072a.18.18 0 1 0 0 .36.18.18 0 0 0 0-.36Zm-.696.263a.18.18 0 1 1-.36 0 .18.18 0 0 1 .36 0Zm-2.589-.109a.18.18 0 1 0 .36 0 .18.18 0 0 0-.36 0Zm6.015-.236a.15.15 0 1 1-.3 0 .15.15 0 0 1 .3 0ZM.361 5.002a.18.18 0 1 0-.36 0 .18.18 0 0 0 .36 0Zm2.427-.173a.18.18 0 1 1-.36 0 .18.18 0 0 1 .36 0ZM1.19 3.434a.125.125 0 1 0 0-.25.125.125 0 0 0 0 .25Zm2.711-.04a.125.125 0 1 1-.25 0 .125.125 0 0 1 .25 0Zm-3.276.327a.15.15 0 1 0 0 .3.15.15 0 0 0 0-.3Zm3.458.612a.18.18 0 1 1 0 .361.18.18 0 0 1 0-.36Zm2.042.544a.18.18 0 1 0 0-.36.18.18 0 0 0 0 .36Zm.223-.614a.18.18 0 1 1-.36 0 .18.18 0 0 1 .36 0Zm.47.585a.18.18 0 1 0 0-.36.18.18 0 0 0 0 .36Zm-1.426.524a.18.18 0 1 1 0-.361.18.18 0 0 1 0 .36ZM.495 4.397a.18.18 0 1 0 0-.36.18.18 0 0 0 0 .36Zm-.058.861c0 .045-.034.081-.076.081-.042 0-.076-.036-.076-.081 0-.045.034-.081.076-.081.042 0 .076.036.076.081Z"
      />
      <path
        d="M2.038 5.191c0 .045.034.081.076.081a.078.078 0 0 0 .076-.08c0-.046-.034-.082-.076-.082-.042 0-.076.036-.076.081ZM4.45 2.91c0 .03-.024.056-.053.056-.029 0-.052-.026-.052-.057 0-.03.023-.056.052-.056.03 0 .053.025.053.056Zm1.234 2.492a.055.055 0 0 0 .053-.056c0-.03-.024-.056-.053-.056-.03 0-.053.025-.053.056s.024.056.053.056ZM1.276 3.647c0 .032-.024.057-.053.057-.029 0-.052-.025-.052-.057 0-.03.023-.056.052-.056.03 0 .053.025.053.056ZM.471 4.9c-.029 0-.052.025-.052.057 0 .03.023.056.052.056.03 0 .053-.025.053-.056A.055.055 0 0 0 .47 4.9Zm1.107-1.825c0 .031-.023.056-.052.056-.03 0-.053-.025-.053-.056s.023-.056.053-.056c.029 0 .052.025.052.056ZM2.92 2.96c.03 0 .053-.025.053-.056s-.024-.056-.053-.056c-.029 0-.052.025-.052.056 0 .03.023.056.052.056Zm.24-.55a.055.055 0 0 1-.053.056c-.03 0-.053-.025-.053-.056 0-.03.024-.056.053-.056.029 0 .052.025.052.056ZM.077 4.61c.032 0 .06-.022.07-.053v.188h.298V4.43H.148v.07a.076.076 0 0 0-.071-.053.078.078 0 0 0-.076.08c0 .046.034.082.076.082Zm1.558-1.265c0 .045-.034.081-.076.081a.078.078 0 0 1-.076-.08c0-.046.034-.082.076-.082.042 0 .076.037.076.081Zm-.327-.637c-.03 0-.053.025-.053.056s.023.056.053.056c.029 0 .052-.025.052-.056 0-.03-.023-.056-.052-.056Zm-.834.289c-.03 0-.053-.025-.053-.056s.024-.057.053-.057c.029 0 .052.026.052.057 0 .03-.023.056-.052.056Zm3.618-.262c.03 0 .053-.025.053-.056 0-.03-.024-.056-.053-.056-.029 0-.053.025-.053.056s.024.056.053.056Zm1.143.288c0 .03-.023.056-.052.056-.03 0-.053-.025-.053-.056s.024-.056.053-.056c.029 0 .052.025.052.056Zm.5-.345c.03 0 .053-.025.053-.056 0-.03-.024-.056-.053-.056-.029 0-.053.025-.053.056s.024.056.053.056Zm-.617-.218c0 .03-.024.056-.053.056-.029 0-.052-.025-.052-.056s.023-.056.052-.056c.03 0 .053.025.053.056ZM7.72 4.886c.042 0 .076-.036.076-.081 0-.045-.034-.081-.076-.081-.042 0-.076.036-.076.081 0 .045.034.081.076.081ZM2.756 2.673c0 .037-.028.067-.063.067s-.064-.03-.064-.067c0-.037.029-.068.064-.068s.063.03.063.068Zm.319 1.709a.127.127 0 1 0 .255 0 .127.127 0 0 0-.255 0ZM1.992 3.023a.127.127 0 1 1-.254 0 .127.127 0 0 1 .254 0Zm3.759 1.713a.127.127 0 1 0 0-.254.127.127 0 0 0 0 .254ZM2.963 3.285a.088.088 0 1 1-.177 0 .088.088 0 0 1 .177 0Zm1.999 1.808a.127.127 0 1 0 0-.254.127.127 0 0 0 0 .254ZM.255 4.216a.127.127 0 1 1-.254 0 .127.127 0 0 1 .254 0Zm.383.522a.127.127 0 1 0 0-.254.127.127 0 0 0 0 .254Zm.376-.854a.106.106 0 1 1 0-.212.106.106 0 0 1 0 .212Zm.893.695a.127.127 0 1 0-.186-.174.127.127 0 0 0 .186.174Zm3.067-.809a.213.213 0 1 1 .426 0 .213.213 0 0 1-.426 0Zm1.11-.218a.213.213 0 1 0 .425 0 .213.213 0 0 0-.425 0Zm1.451.884a.255.255 0 1 1-.509.04.255.255 0 0 1 .51-.04ZM2.2 3.872a.213.213 0 1 0-.425 0 .213.213 0 0 0 .425 0Zm1.255-.291a.213.213 0 1 1-.426 0 .213.213 0 0 1 .426 0Zm.928.109a.213.213 0 1 0 .426 0 .213.213 0 0 0-.426 0Zm.939 1.272a.255.255 0 1 1 0-.51.255.255 0 0 1 0 .51Zm2.578.105h-.327v.345h.328v-.345Zm-6.536.567h.432v.455h-.432v-.455ZM4.17 3.589h-.156v.164h.156V3.59Zm.15-1.294h.156v.165h-.157v-.165Zm2.762 3.023a.198.198 0 1 0 .397 0 .198.198 0 0 0-.397 0ZM.68 5.21a.198.198 0 1 1-.066.384v.232H.286V5.48h.21a.198.198 0 0 1 .185-.27Zm1.17.728a.218.218 0 1 0 .435 0 .218.218 0 0 0-.436 0ZM.084 5.49C.038 5.49 0 5.45 0 5.4c0-.05.038-.089.084-.089.046 0 .084.04.084.09a.087.087 0 0 1-.084.088ZM.82 2.843c.054 0 .1-.047.1-.106 0-.06-.046-.107-.1-.107-.056 0-.101.047-.101.107 0 .059.045.106.1.106Zm9.922 7.71c.055 0 .1.048.1.107 0 .06-.045.107-.1.107-.056 0-.1-.047-.1-.107 0-.059.044-.107.1-.107Zm3.263 1.913c0 .059.044.107.1.107.055 0 .1-.048.1-.107 0-.06-.045-.107-.1-.107-.056 0-.1.048-.1.107Zm-2.974.24h.207v.218h-.207v-.218Zm2.905-.344h-.248v.261h.248v-.261Zm-.227.453h.207v.218h-.207v-.218Zm.885-.253h-.206v.218h.206v-.218Zm.605-.72h.297v.313H15.2v-.313Zm-1.139-.41Zm0 0h.297v-.164a.255.255 0 1 0 .204-.369.088.088 0 1 0-.08.021.255.255 0 0 0-.149.198h-.273v.314Zm-3.467.903h.248v.261h-.248v-.261Zm1.323.554h-.207v.217h.207v-.217Zm1.041.095h.207v.217h-.207v-.217Zm.86-.879h.298v-.219h.26v-.379h-.36v.285h-.198v.313Zm-3.336-.32h.36v.38h-.36v-.38Zm2.372.462h-.248v.261h.248v-.261Zm-.755.519h.207v.217h-.207v-.217Zm-.391-1.326h-.298v.314h.298v-.314Zm-1.85.668h.248v.262h-.248v-.262Zm1.693.866h-.13v.136h.13v-.136Zm-1.193-.07h.13v.136h-.13v-.136Zm2.01.638h-.129v.136h.13v-.136Zm-1.551-.124h.13v.136h-.13v-.136Zm2.147-.605h-.107v.114h.107v-.114Z"
      />
      <path
        d="M14.175 10.907h.108v.114h-.108v-.114Zm1.13.767h-.107v.113h.107v-.114Zm-3.992 1.501h.107v.114h-.107v-.114Zm2.267-3.115h-.108v.114h.107v-.113Zm-2.63 1.853h.13v.136h-.13v-.136Zm-1.35-.14h-.038a.255.255 0 0 0-.244-.442V11.1h-.297v.313h.184a.255.255 0 0 0 .24.411v.113H9.6v-.163Zm3.863.457h.13v.137h-.13v-.136Zm-1.94.448h-.13v.137h.13v-.136Zm.69-.7h.248v.261h-.248v-.261Zm-.201-.517a.127.127 0 0 0-.252.015.127.127 0 0 0 .214.092v.155h.248v-.262h-.21Zm2.758.874h.249v.261h-.248v-.261Zm.35-1.033h-.298v.314h.298v-.314Zm-.553.561h.144v.152h-.144v-.152Zm-1.639 1.472h-.144v.151h.144v-.152Zm-3.046-2.109h.143v.152h-.143v-.152Zm1.612.679h-.144v.152h.144v-.152Zm-.717.785a.125.125 0 1 1 0 .25.125.125 0 0 1 0-.25Zm3.328-.054a.125.125 0 1 0 0 .25.125.125 0 0 0 0-.25Zm-2.242-.174h.009a.125.125 0 1 1-.125.124v-.011h-.185v-.314h.298v.202l.003-.001Zm.707.578a.125.125 0 1 0-.001.25.125.125 0 0 0 0-.25Zm.26-1.03a.18.18 0 0 1-.04-.356h-.033v-.217h.207v.218h-.093a.18.18 0 0 1-.04.356Zm2.109-.215a.18.18 0 1 0 0 .36.18.18 0 0 0 0-.36Zm-5.217.092a.15.15 0 1 1 0 .3.15.15 0 0 1 0-.3Zm4.078-.705a.18.18 0 1 0 0 .36.18.18 0 0 0 0-.36Zm-1.28 1.579a.125.125 0 1 1 .25 0 .125.125 0 0 1-.25 0Zm-.074-1.288a.18.18 0 1 0 0 .36.18.18 0 0 0 0-.36Z"
      />
      <path
        d="M10.252 11.712a.18.18 0 1 1-.167.112H9.8v-.38h.318a.18.18 0 0 1 .166-.25.18.18 0 1 1-.124.311v.233a.179.179 0 0 1 .093-.026Zm.956-.748a.18.18 0 1 0-.36 0 .18.18 0 0 0 .36 0Zm.873 2.226c0-.032.024-.057.053-.057.029 0 .053.025.053.056s-.024.056-.053.056c-.03 0-.053-.025-.053-.056Zm-1.45-2.324c0 .03.024.056.053.056.029 0 .053-.025.053-.056s-.024-.056-.053-.056c-.03 0-.053.025-.053.056Zm3.664-.804c.03 0 .053.025.053.056 0 .03-.024.056-.053.056-.029 0-.052-.025-.052-.056s.023-.056.052-.056ZM11.37 13.49c-.029 0-.052.026-.052.057 0 .031.023.056.052.056.03 0 .053-.025.053-.056 0-.03-.024-.056-.053-.056Zm-.003-2.212c0-.03.024-.056.053-.056.03 0 .053.025.053.056s-.024.056-.053.056a.055.055 0 0 1-.053-.056Zm-1.854-.61c.03 0 .053-.025.053-.056 0-.03-.024-.056-.053-.056-.029 0-.052.025-.052.056s.023.056.052.056Zm3.828 2.439c0-.031.024-.056.053-.056.03 0 .053.025.053.056 0 .03-.024.056-.053.056a.055.055 0 0 1-.053-.056Zm1.819-.86c-.03 0-.053.025-.053.056s.024.056.053.056c.03 0 .053-.025.053-.056 0-.03-.024-.056-.053-.056Zm-3.975.886c0-.031.024-.057.053-.057.029 0 .053.025.053.056 0 .032-.024.057-.053.057-.03 0-.053-.025-.053-.056Zm-.291-.026c0-.03-.023-.056-.052-.056-.03 0-.053.025-.053.056s.024.056.053.056c.029 0 .052-.025.052-.056Zm2.196-1.143a.127.127 0 1 1 .255 0 .127.127 0 0 1-.254 0Zm-1.23 1.332a.127.127 0 1 0 0 .254.127.127 0 0 0 0-.254Zm-1.103-1.842a.127.127 0 1 1-.175.186.127.127 0 0 1 .175-.186Zm2.877 1.416a.088.088 0 1 0-.176 0 .088.088 0 0 0 .176 0Zm-.034.434a.088.088 0 1 1 .176 0 .088.088 0 0 1-.176 0Zm-3.718-.806a.088.088 0 1 0 0 .176.088.088 0 0 0 0-.176Zm4.391.541a.088.088 0 1 1 .176 0 .088.088 0 0 1-.176 0Zm.333-1.502a.127.127 0 1 0 0 .254.127.127 0 0 0 0-.254Zm-3.159.848a.213.213 0 1 1-.426 0 .213.213 0 0 1 .426 0Zm-1.06-.089v-.088h-.13v.123a.213.213 0 1 0 .13-.035Z"
      />
      <path
        d="M13.314 11.848a.255.255 0 1 1 .166-.063h.237v.314h-.298v-.274a.256.256 0 0 1-.105.023Zm1.119.223a.213.213 0 1 0 0 .426.213.213 0 0 0 0-.426Zm-1.131.331a.213.213 0 1 1-.248 0v-.233h.248v.233Zm-1.43-.634a.213.213 0 1 0 0 .425.213.213 0 0 0 0-.425Zm-.518-.319a.255.255 0 1 1-.51 0 .255.255 0 0 1 .51 0Zm1.052.953h-.156v.165h.156v-.165Z"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M15.94 9.373a.308.308 0 0 1 .059.181H16c0 .091-.04.172-.102.228h.051v.24h-.044a.088.088 0 1 1-.123 0h-.061V9.86a.305.305 0 0 1-.165-.031v.097a.127.127 0 0 1-.036.249.127.127 0 0 1-.08-.225h-.204a.312.312 0 0 1-.096.089h.018v.136h-.13v-.097a.307.307 0 0 1-.19-.033v.13h-.207v-.218h.106a.306.306 0 0 1-.06-.219.342.342 0 0 1-.163.045v.244h-.433v-.36a.47.47 0 0 1-.081.03.216.216 0 0 1-.094.304v.174h-.187v-.172a.219.219 0 0 1-.122-.153.218.218 0 0 1-.19.053v.271h-.433V9.72h.261a.216.216 0 0 1 .03-.143.227.227 0 0 1-.145-.073.56.56 0 0 1-.234.247.31.31 0 1 1-.566-.017.56.56 0 0 1-.168-.162h-.155v.001a.218.218 0 0 1-.114.192v.066h.317v.345h-.327v-.22h-.177v-.181a.218.218 0 0 1-.131-.163.559.559 0 0 1-.166.219h.103v.345h-.327v-.237a.565.565 0 0 1-.152.013h-.006a.127.127 0 0 1-.082.224.127.127 0 0 1-.045-.246.557.557 0 0 1-.136-.062.309.309 0 0 1-.214.391.2.2 0 1 1-.154.002.309.309 0 0 1-.236-.306v-.006a.614.614 0 0 1-.17-.005v.137h.111v.455h-.067a.28.28 0 0 1 .266.257h.24V11h.236v.314h-.298v-.177h-.265v-.117a.28.28 0 0 1-.38.005.18.18 0 1 1-.32.038h-.177v-.313h.298v.2a.18.18 0 0 1 .048-.007c.043 0 .082.015.113.04a.28.28 0 0 1 .211-.448H9.66v-.239a.284.284 0 0 1-.365.162v.26h-.172v.287h-.328v-.345h.107v-.278h-.28v-.304a.34.34 0 0 1-.137-.277v-.62c.018-.313.07-.612.156-.897h.001a3.753 3.753 0 0 1 .966-1.574c.752-.752 1.655-1.128 2.709-1.128 1.013 0 1.88.36 2.603 1.083.476.476.795 1.017.957 1.62h-.003c.077.287.12.588.126.904h-.004v.023a.26.26 0 0 1-.055.162Zm-7.022.761v.17h.215a.286.286 0 0 1-.022-.092.31.31 0 0 1-.123-.106.33.33 0 0 1-.07.028Zm1.837-1.85c-.07.12-.126.247-.171.382h3.31a2.062 2.062 0 0 0-.172-.382h.002a2.003 2.003 0 0 0-.445-.528 1.558 1.558 0 0 0-1.038-.369c-.402 0-.748.123-1.04.369-.18.154-.33.33-.444.528h-.002Z"
      />
      <path
        d="M11.916 13.696a.067.067 0 1 0 0 .133.067.067 0 0 0 0-.133Zm1.331-.086a.067.067 0 1 1 .133 0 .067.067 0 0 1-.133 0Z"
      />
    </g>

    <path
      v-else-if="icon === 'online'"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8 2C4.68629 2 2 4.68629 2 8V8.08535C2.15639 8.03008 2.32468 8 2.5 8H3.5C4.32843 8 5 8.67157 5 9.5V13.5C5 14.3284 4.32843 15 3.5 15H2.5C1.67157 15 1 14.3284 1 13.5V8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8V13.5C15 14.3284 14.3284 15 13.5 15H12.5C11.6716 15 11 14.3284 11 13.5V9.5C11 8.67157 11.6716 8 12.5 8H13.5C13.6753 8 13.8436 8.03008 14 8.08535V8C14 4.68629 11.3137 2 8 2ZM14 9.5C14 9.22386 13.7761 9 13.5 9H12.5C12.2239 9 12 9.22386 12 9.5V13.5C12 13.7761 12.2239 14 12.5 14H13.5C13.7761 14 14 13.7761 14 13.5V9.5ZM2 9.5C2 9.22386 2.22386 9 2.5 9H3.5C3.77614 9 4 9.22386 4 9.5V13.5C4 13.7761 3.77614 14 3.5 14H2.5C2.22386 14 2 13.7761 2 13.5V9.5Z"
    />
  </svg>
</template>

<script setup>
import { useUserStore } from "@/stores/user";
const userStore = useUserStore();

const props = defineProps({
  role: {
    type: String,
    required: false,
    default: "presentation",
  },
  icon: {
    type: String,
    required: true,
    validator: function (value) {
      return (
        [
          "bullet",
          "close",
          "hamburger",
          "kebab",
          "mail",
          "filters",
          "angle-up",
          "angle-down",
          "angle-left",
          "world",
          "user",
          "user-pro",
          "user-logged",
          "search",
          "store-locator",
          "pin",
          "arrow-long-left",
          "arrow-long-right",
          "arrow-long-down",
          "download",
          "gallery",
          "moodboard",
          "add-to-moodboard",
          "add-to-favorites",
          "favourite",
          "favourite-added",
          "book-consultancy",
          "plus",
          "minus",
          "email",
          "info",
          "success",
          "warning",
          "error",
          "lock",
          "edit",
          "share",
          "duplicate",
          "remove",
          "work-with-us",
          "faq",
          "url",
          "configurator",
          "thumbs-grid",
          "thumbs-list",
          "play",
          "pause",
          "audio-on",
          "audio-off",
          "fullscreen-on",
          "fullscreen-off",
          "certification",
          "handbook-maintenance",
          "handbook-laying",
          "handbook-cleaning",
          "handbook-informative",
          "monograph-catalog",
          "password-visible",
          "password-hidden",
          "external-link",
          "hires-img",
          "resource",
          "online",
        ].indexOf(value) !== -1
      );
    },
  },
  size: {
    type: String,
    required: false,
    validator: function (value) {
      return (
        ["tiny", "small", "regular", "big", "huge", "giant", "titan"].indexOf(
          value
        ) !== -1
      );
    },
  },
});
</script>
